export function dateToIsoString(date?: Date): string | undefined {
    if (!date) return

    const offset = date.getTimezoneOffset()
    const offsetHours = Math.abs(Math.floor(offset / 60))
    const offsetMinutes = Math.abs(offset % 60)

    const offsetSign = offset > 0 ? '-' : '+'
    const offsetString = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`

    const localIsoString = new Date(date.getTime() - offset * 60000).toISOString().slice(0, -1)

    return `${localIsoString}${offsetString}`
}
